<div class="gl-notifications">
  <div *ngIf="progress" class="gl-notifications__item">
    <div class="gl-notifications__item--title">
      {{ 'notifications.bulk.' + messageLabel + '.progressTitle' | translate }}
    </div>
    <span class="gl-notifications__item--message">{{
      'notifications.bulk.' + messageLabel + '.progressText' | translate
    }}</span>
    <!-- <span class="gl-notifications__item--message">{{'notifications.bulk.progressPercent' | translate: {percent: percent} }}</span> -->
    <div class="gl-notifications__item--close">
      <span class="glicon-close" (click)="removeProgress()"></span>
    </div>
    <div *ngIf="percent !== 100" class="gl-notifications__item--feedback">
      <lms-button-spinner></lms-button-spinner>
      <span>{{ 'notifications.bulk.progressPercent' | translate : { percent: percent } }}</span>
    </div>
    <div *ngIf="percent === 100" class="gl-notifications__item--feedback success">
      <span class="glicon-check-circle"></span>
      <span>{{ 'notifications.bulk.progressPercent' | translate : { percent: percent } }}</span>
    </div>
  </div>

  <div *ngIf="isEnrollment" class="gl-notifications__item">
    <div>
      <div class="gl-notifications__item--title">
        <span *ngIf="erroredStudentsCount == 0" class="glicon-check-circle success"></span>
        <span *ngIf="erroredStudentsCount > 0" class="glicon-alert failed"></span>
        <span>{{ 'notifications.bulk.' + messageLabel + '.successTitle' | translate }}</span>
      </div>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successEnrolled'
          | translate : "{ number:'" + enrolledStudentsCount + "'}"
      }}</span>
      <span *ngIf="hasToReEnroll" class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successReEnrolled'
          | translate : "{ number:'" + reEnrolledStudentsCount + "'}"
      }}</span>
      <span *ngIf="!hasToReEnroll" class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successNotEnrolled'
          | translate : "{ number:'" + notReEnrolledStudentsCount + "'}"
      }}</span>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successEnrolledError'
          | translate : "{ number:'" + erroredStudentsCount + "'}"
      }}</span>
    </div>
    <div class="gl-notifications__item--link">
      <span *ngIf="erroredStudentsCount" class="gl-notifications__item--link__error" (click)="downloadCSV(errors)">
        {{ 'notifications.bulk.create_licenses_batch.downloadErrors' | translate }}
      </span>
      <span
        *ngIf="reEnrolledStudentsCount || notReEnrolledStudentsCount"
        class="gl-notifications__item--link__success"
        (click)="downloadCSV(hasToReEnroll ? reEnrolledStudents : notReEnrolledStudents)"
      >
        {{ 'notifications.bulk.create_licenses_batch.' + enrollButton | translate }}
      </span>
    </div>
    <div class="gl-notifications__item--close">
      <span (click)="removeFinished()" class="glicon-close"></span>
    </div>
  </div>

  <div *ngIf="(isEmailNotification && success) || (errors && isEmailNotification)" class="gl-notifications__item">
    <div>
      <div class="gl-notifications__item--title">
        <span *ngIf="errored && errored !== total" class="glicon-alert failed"></span>
        <span *ngIf="errored && errored === total" class="glicon-close-circle failed"></span>
        <span *ngIf="!errored" class="glicon-check-circle success"></span>
        <span>{{ 'notifications.bulk.' + messageLabel + '.' + getEmailMessage() | translate }}</span>
      </div>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successEnrolled' | translate : "{ number:'" + updated + "'}"
      }}</span>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successEnrolledError' | translate : "{ number:'" + errored + "'}"
      }}</span>
    </div>
    <div class="gl-notifications__item--link">
      <span *ngIf="errored" class="gl-notifications__item--link__error" (click)="downloadCSV(errors)">
        {{ 'notifications.bulk.create_licenses_batch.downloadErrors' | translate }}
      </span>
    </div>
    <div class="gl-notifications__item--close">
      <span (click)="removeFinished()" class="glicon-close"></span>
    </div>
  </div>

  <div *ngIf="success && !isEnrollment && !isEmailNotification" class="gl-notifications__item">
    <div>
      <div class="gl-notifications__item--title">
        <span class="glicon-check-circle success"></span>
        <span>{{ 'notifications.bulk.' + messageLabel + '.successTitle' | translate }}</span>
      </div>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.successText' | translate
      }}</span>
    </div>
    <div *ngIf="fileUrl || notificationUrl" class="gl-notifications__item--link">
      <a *ngIf="fileUrl" [href]="fileUrl" target="_blank" class="gl-notifications__item--link__success">{{
        'nouns.download' | translate
      }}</a>
      <span *ngIf="notificationUrl" class="gl-notifications__item--link__success" (click)="navUrlEmit()">{{
        'notifications.bulk.' + messageLabel + '.navLink' | translate
      }}</span>
    </div>
    <div class="gl-notifications__item--close">
      <span (click)="removeFinished()" class="glicon-close"></span>
    </div>
  </div>

  <div *ngIf="errors && !isEnrollment && !isEmailNotification" class="gl-notifications__item">
    <div>
      <div class="gl-notifications__item--title">
        <span class="glicon-alert failed"></span>
        <span>{{ 'notifications.bulk.' + messageLabel + '.errorTitle' | translate }}</span>
      </div>
      <!-- <span class="gl-notifications__item--message">{{'notifications.bulk.' + messageLabel + '.errorText' | translate}}</span> -->
    </div>
    <div class="gl-notifications__item--link">
      <span class="gl-notifications__item--link__error" (click)="downloadCSV(errors)">{{
        'notifications.errorView' | translate
      }}</span>
    </div>
    <div class="gl-notifications__item--close">
      <span (click)="removeError()" class="glicon-close"></span>
    </div>
  </div>

  <div *ngIf="fatalError" class="gl-notifications__item">
    <div>
      <div class="gl-notifications__item--title">
        <span class="glicon-alert failed"></span>
        <span>{{ 'notifications.bulk.' + messageLabel + '.fatalErrorTitle' | translate }}</span>
      </div>
      <span class="gl-notifications__item--message">{{
        'notifications.bulk.' + messageLabel + '.fatalErrorText' | translate
      }}</span>
    </div>
    <div class="gl-notifications__item--link">
      <span class="gl-notifications__item--link__error" (click)="downloadCSV(fatalError)">{{
        'notifications.errorView' | translate
      }}</span>
    </div>
    <div class="gl-notifications__item--close">
      <span (click)="removeFatalError()" class="glicon-close"></span>
    </div>
  </div>
</div>
